import type { BookingAnalyticsResponse } from "@/queries/analytics/booking-reporting-types";

export function hasMultipleBookingOrigins(originCounts: BookingAnalyticsResponse["originCounts"] | undefined): boolean {
  return (originCounts?.projectOnly ?? 0) > 0 && (originCounts?.projectConnection ?? 0) > 0;
}
